import React from 'react';
export default function CloseButton(props) {
    return React.createElement("div", { className: "close-button close fe fe-x", onClick: props.onClick });
}
